import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ModalForm from "./ModalForm";
import { useContext } from "../Context";

export default function UpdateBillingInfoButton() {
  const { dispatch, actions, state } = useContext();
  const [loading, setLoading] = useState(false);

  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <Button
        className="w-200"
        onClick={() => setShowForm(true)}
        bsStyle="primary"
      >
        Update Billing Info
      </Button>
      <ModalForm showForm={showForm} closeForm={() => setShowForm(false)} />
    </>
  );
}
